import { Injectable } from '@angular/core';
import { RefreshService } from '../../shared/services/refresh-service';

@Injectable({
  providedIn: 'root',
})
export class DriverRefreshService extends RefreshService {}
